const convertToUSD = (currency: string | number) => {
    let formattedCurrency: string;
    if (typeof currency === 'number') {
        formattedCurrency = currency.toFixed(2).toString().replace(/,/g, ".");
    } else {
        formattedCurrency = currency.toString().replace(/,/g, ".");
    }
    return formattedCurrency.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const convertToCAD = (currency: string | number) => {
    let formattedCurrency: string;
    if (typeof currency === 'number') {
        formattedCurrency = currency.toFixed(2).toString().replace(/\./g, ",")
    } else {
        formattedCurrency =  currency.toString().replace(/\./g, ",")
    }
    return formattedCurrency.replace(/\B(?=(\d{3})+(?!\d))/g, "\u00A0");
}

export { convertToUSD, convertToCAD };